import request from '@/apis/request'
const resource = 'service'

export default {
  getCurrentGame: (params = {}) => {
    return request.get(`${resource}/current-game`, { params })
  },

  getLogin: (uid) => {
    return request.get(`${resource}/game-types/${uid}`)
  },

  getLoginMobile: (uid) => {
    return request.get(`${resource}/game-types/${uid}/mobile`)
  },

  getLoginGame: (uid) => {
    return request.get(`${resource}/games/${uid}`)
  },

  getLoginGameMobile: (uid) => {
    return request.get(`${resource}/games/${uid}/mobile`)
  },

  getLoginGameDesktop: (uid) => {
    return request.get(`${resource}/games/${uid}/desktop`)
  },

  getActiveGameById: (uid) => {
    return request.get(`${resource}/game-types/${uid}/active`)
  },

  postTransfer: (uid) => {
    return request.post(`${resource}/game-types/${uid}/transfer`)
  },

  putLogout: (uid) => {
    return request.put(`${resource}/game-types/${uid}`)
  },

  putWithdrawById: (id, uid) => {
    return request.put(`${resource}/game-types/${id}/${uid}`)
  },
}